import { createSlice } from '@reduxjs/toolkit';

const initialState = require('../initialState').optionsInitialState;

const options = createSlice({
    name: 'options',
    initialState,
    reducers: {
        setAccountPayableShowOverdue: (state, action) => {
            state.accountPayableShowOverdue = action.payload;
        }
    }
});

export default options.reducer;

export const { setAccountPayableShowOverdue } = options.actions;
